import { render, staticRenderFns } from "./ReportP1.vue?vue&type=template&id=00c04e88&"
import script from "./ReportP1.vue?vue&type=script&lang=js&"
export * from "./ReportP1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports